import React, { useState, useEffect } from "react";
import { Button, Grid } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import OrderInfo from "../orderInfo";
import MapContainer from "../mapContainer";
import "animate.css/animate.css";
import httpRequest from "../../../HttpService";

const Review = (props) => {
  const [isUpdateMap, setIsUpdateMap] = useState(false);
  const [isCreatingOrder, setIsCreatingOrder] = useState(false);
  const [readyAtDateChecked, setReadyAtDateChecked] = useState(false);

  useEffect(() => {
    props.onAlert({"target":"Initial", "value":false});
  }, []);

  // Add Ctrl+Enter hotkey for Finished button in step 5
  useEffect(() => {
    // Only add listener when on step 5
    if (props.expanded !== 5) return;

    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
        if (props.info[4].timeOption !== null && !isCreatingOrder) {
          event.preventDefault();
          event.stopPropagation();
          createTrip();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [props.expanded, props.info[4]?.timeOption, isCreatingOrder]);
  
  const createTrip = async () => {
    if (isCreatingOrder) return;
  
    setIsCreatingOrder(true);
    try {
      localStorage.setItem("pickupLocation", "");
      localStorage.setItem("deliveryLocation", "");
  
      // Detailed logging of return trip data
      if (props.info[4]?.isReturnTripEnabled) {
        console.log("Return trip is enabled");
        
        if (props.info[4]?.returnTripOption) {
          console.log("Return trip option full details:", props.info[4].returnTripOption);
          
          // Log all possible ID properties
          console.log("Return trip IDs available:", {
            timeOptionID: props.info[4].returnTripOption.timeOptionID,
            quoteTimeOptionID: props.info[4].returnTripOption.quoteTimeOptionID,
            quoteID: props.info[4].returnTripOption.quoteID,
            optionID: props.info[4].returnTripOption.optionID,
            allKeys: Object.keys(props.info[4].returnTripOption)
          });
        } else {
          console.log("Return trip enabled but no option selected");
        }
      }
  
      // Try all possible ID properties from the return trip option
      let returnTripOptionID = null;
      if (props.info[4]?.isReturnTripEnabled && props.info[4]?.returnTripOption) {
        returnTripOptionID = props.info[4].returnTripOption.quoteTimeOptionID || 
                             props.info[4].returnTripOption.timeOptionID;
        
        console.log("Using return trip option ID:", returnTripOptionID);
      }
  
      console.log("Creating trip with parameters:", {
        firstLegTimeOptionID: props.info[4].timeOption.quoteTimeOptionID,
        companyID: '1',
        next: 0,
        returnTripOptionID: returnTripOptionID
      });
  
      const res = await httpRequest.postQuoteExecute(
        props.info[4].timeOption.quoteTimeOptionID,
        '1',
        0,
        returnTripOptionID,
        props.info[0].quoteId
      );
  
      console.log("postQuoteExecute_data FULL:", res.data);
      props.onChange({ "target": "postQuoteExecute_data", "value": res.data[0] });
      props.onChange({ "target": "jobID", "value": res.data[0].jobID });
      props.onChange({ "target": "nextQuoteID", "value": res.data[0].nextQuoteID || null });
      props.updateCounterStatus(2);
      props.onNextPanel();
    } catch (error) {
      console.error('Error creating trip:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      }
    } finally {
      setIsCreatingOrder(false);
    }
  };

  const createTripAndNew = () => {
    console.log("Review createTripAndNew pickUpLocation-" + JSON.stringify(props.info[1].pickUpLocation));
    console.log("Review createTripAndNew deliveryLocation-" + JSON.stringify(props.info[1].deliveryLocation));
  
    localStorage.setItem("pickupLocation", JSON.stringify(props.info[1].pickUpLocation));
    localStorage.setItem("deliveryLocation", JSON.stringify(props.info[1].deliveryLocation));
  
    // Check if return trip is enabled and we have a selected option
    let returnTripOptionID = null;
    if (props.info[4]?.isReturnTripEnabled && props.info[4]?.returnTripOption) {
      // Use quoteTimeOptionID instead of timeOptionID
      returnTripOptionID = props.info[4].returnTripOption.quoteTimeOptionID;
      console.log("Creating trip and new with return quoteTimeOptionID:", returnTripOptionID);
    }
  
    httpRequest.postQuoteExecute(
      props.info[4].timeOption.quoteTimeOptionID,
      '1',
      1,
      returnTripOptionID,
      props.info[0].quoteId
    ).then((res) => {
      console.log("postQuoteExecute_data", JSON.stringify(res.data));
      props.onChange({ "target": "jobID", "value": res.data[0].jobID });
      props.onChange({ "target": "nextQuoteID", "value": res.data[0].nextQuoteID || null });
      props.onChange({ "target": "postQuoteExecute_data", "value": res.data[0] });
      props.updateCounterStatus(2);
    }).catch((error) => {
      console.error('Error creating trip and new:', error);
      if (error.response) {
        console.error("Error response data:", error.response.data);
      }
    });
  
    props.newOrderPanel();
  };

  return (
      <Grid 
        container 
        direction="row" 
        justifyContent="space-between" 
        alignItems="stretch"
        spacing={4}
        style={{ display: 'flex', minHeight: '100%' }}
      >
        <Grid 
          item 
          sm={10} 
          md={7} 
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          { (props.info[1].pickUpLocation && props.info[1].deliveryLocation && props.info[4].timeOption) ? (
            <OrderInfo
              name={props.info[0].caller}
              callIn={props.info[4].timeOption?.dtPickupStart}
              dueBy={props.info[4].timeOption?.dtDeliveryEnd}
              fromName={props.info[1].pickUpLocation.companyName}
              fromAddress={props.info[1].pickUpLocation.address + (props.info[1].pickUpLocation.quad? ", " + props.info[1].pickUpLocation.quad : "")}
              toName={props.info[1].deliveryLocation.companyName}
              toAddress={ props.info[1].deliveryLocation.address +(props.info[1].deliveryLocation.quad? ", " +props.info[1].deliveryLocation.quad: "")}
              pieces={props.info[2].pieces}
              pieceDescriptionOverride={props.info[2].pieceDescriptionOverride}
              weight={props.info[2].weight}
              weightUnit={props.info[2].weightUnit || 'lbs'}
              instructions={props.info[3].instructions}
              rate={{Rate:props.info[4].timeOption.RATE}}
              returnTripService={props.info[4].returnTripOption} // Pass the return trip option data
              packageSize={props.info[2].packageSize}
              packageDesc={props.info[2].packageDesc}
              packageImage={props.info[2].packageImage}
              references={props.info[3]}
              signatureRequired={props.info[3].signatureRequired}
              pictureRequired={props.info[3].pictureRequired}
              prevPanel={props.onNextPanel}
              nextPanel={props.onNextPanel}
            />) : ""
          }
          <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={3}>          
            <Grid item xs={12} md={12} container direction="row">
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={props.info[4].timeOption === null || isCreatingOrder}
                  style={{ float: "left", margin: "2px" }}
                  startIcon={
                    <DoneIcon
                      style={{
                        verticalAlign: "middle",
                        transform: "scale(1.5)",
                      }}
                    />
                  }
                  onClick={createTrip}
                  tabIndex={-1}
                >
                  Finished (Ctrl + Enter)
                </Button>
              </Grid>
              <Grid item xs={8}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={props.info[4].timeOption === null ||isCreatingOrder}
                  style={{ float: "right", margin: "2px", display: "none" }}
                  startIcon={
                    <DoneIcon
                      style={{
                        verticalAlign: "middle",
                        transform: "scale(1.5)",
                      }}
                    />
                  }
                  onClick={createTripAndNew}                 
                >
                  Finished And Create a new Order
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid 
          item 
          sm={10} 
          md={5}
          style={{ 
            display: 'flex',
            flexDirection: 'column',
            flex: 1
          }}
        >
        { (props.info[1].pickUpLocation && props.info[1].deliveryLocation && props.info[4].timeOption) ? (
            <div style = {{height:"420px"}}>
              <MapContainer
              top={0}
              IsUpdateMap={isUpdateMap}
              consignAddress={
                props.info[1].deliveryLocation.address +
                " " +
                (props.info[1].deliveryLocation.quad ? " " + props.info[1].deliveryLocation.quad + ", " : "") + props.info[1].deliveryLocation.city +
                " " +
                props.info[1].deliveryLocation.prov +
                ", " +
                props.info[1].deliveryLocation.postal
              }
              consignCoord={{lat: props.info[1].deliveryLocation.lat, long: props.info[1].deliveryLocation.long,}}
              shipperAddress={
                props.info[1].pickUpLocation.address +
                " " +
                (props.info[1].pickUpLocation.quad? " " + props.info[1].pickUpLocation.quad + ", " : "") + props.info[1].pickUpLocation.city +
                " " +
                props.info[1].pickUpLocation.prov +
                ", " +
                props.info[1].pickUpLocation.postal
              }
              shipperCoord={{lat: props.info[1].pickUpLocation.lat, long: props.info[1].pickUpLocation.long,}}
              type="directions"
            /> </div>) : ""          
          }
        </Grid>
      </Grid>
    );
};

export default Review;